/**
 * TypingIndicator - Shows who is typing in the group chat.
 */

import { useGroupChat } from '../GroupChatContext'

export function TypingIndicator() {
  const { typingUsers } = useGroupChat()

  if (typingUsers.length === 0) return null

  let text: string
  if (typingUsers.length === 1) {
    text = `${typingUsers[0]} is typing...`
  } else if (typingUsers.length === 2) {
    text = `${typingUsers[0]} and ${typingUsers[1]} are typing...`
  } else {
    text = `${typingUsers[0]} and ${typingUsers.length - 1} others are typing...`
  }

  return (
    <div className="px-4 py-1.5 bg-white border-t border-pink-100">
      <p className="text-pink-400 text-xs animate-pulse">{text}</p>
    </div>
  )
}
